import { app } from '../app/app.js';
import { log } from '../app/logger.js';
import { navigation } from '../app/navigation.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { MessageBox } from './message_box.js';

/**
 * A helper mixin class to manage account forms.
 */
const AccountFormMixin = Base =>
  class extends Base {
    setMessageBox() {
      this.msgBox = new MessageBox(this.messageBoxElement);
    }

    setLoginListeners() {
      listenToEvent(this.formElement, 'submit', () => this.login(), {
        preventDefault: true,
        blockUI: true,
      });

      listenToEvent(this.signupLink, 'click', () => navigation.toSignup(), {
        preventDefault: true,
      });
    }

    /**
     * Logs the user in.
     */
    async login(email = this.emailElement.value, pwd = this.pwdElement.value) {
      log(`[account] ${email} login`);
      this.msgBox.hide();

      let error = await app.login({ email, pwd });
      if (!error) {
        return true;
      }

      log(`[account] ${email} login failed, error: ${error}`);
      if (error == app.BadCredentials) {
        this.msgBox.error(`
          Forgot your password? Click <a href='/recover-pwd'>here</a>
          for a recovery email.`);

        listenToEvent(
          this.messageBoxElement.querySelector('a'),
          'click',
          () => this.recover(email),
          {
            preventDefault: true,
            blockUI: true,
          }
        );
        return false;
      }

      this.msgBox.unexpectedError();
      return false;
    }

    /**
     * Initiates password recovery.
     */
    async recover(email, ev) {
      log(`[account] send recover email to ${email}`);
      if (ev) {
        ev.preventDefault();
      }

      this.msgBox.hide();

      let result = await app.recoverPassword(email);
      if (result == app.Success) {
        this.msgBox.success(`
          Password recovery email was sent. If you have an account with us, then
          you will receive an email shortly. Please check your inbox.
        `);
        return;
      }
      this.msgBox.error(`
        Failed to initiate password recovery. Please reach us at
        <a href='mailto:support@camperaid.com'>support@camperaid.com</a>.
      `);
    }

    static get selectors() {
      return Object.assign({}, super.selectors, {
        Email: `input[autocomplete='username']`,
        Form: `form`,
        MessageBox: `.msg`,
        Name: `input[autocomplete='name']`,
        Pwd: `input[type='password']`,
        SignupLink: `.signup-link`,
        SubmitButton: `button[type='submit']`,
      });
    }

    static get elements() {
      return {
        emailElement: this.selectors.Email,
        formElement: this.selectors.Form,
        messageBoxElement: this.selectors.MessageBox,
        nameElement: this.selectors.Name,
        pwdElement: this.selectors.Pwd,
        submitButton: this.selectors.SubmitButton,
        signupLink: this.selectors.SignupLink,
      };
    }
  };

export { AccountFormMixin };
